import { ReactNode, createContext } from "react";
import useContaProvisionada, { ContaProvisionadaType, CreateContaProvisionadaType, UpdateContaProvisionadaType  } from "./hooks/useContaProvisionada";

interface ContaProvisionadaContextProviderProps {
    children: ReactNode;
}

export interface ContaProvisionadaContextData {
    getAllContaProvisionadaPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
    ) => Promise<ContaProvisionadaType[] | null>;
    setContaProvisionada: any;
    contaProvisionada: ContaProvisionadaType;
    setListContaProvisionada: any;
    listContaProvisionada: ContaProvisionadaType[];
    setInitialListContaProvisionada: any;
    initialListContaProvisionada: ContaProvisionadaType[];
    setContaProvisionadaPageCount: any;
    contaProvisionadaPageCount: number;
    createContaProvisionada: (createContaProvisionadaType: CreateContaProvisionadaType) => Promise<CreateContaProvisionadaType | null>;
    updateContaProvisionada: (updateContaProvisionadaType: UpdateContaProvisionadaType) => Promise<UpdateContaProvisionadaType | null>;
    deleteContaProvisionada: (id: number) => Promise<ContaProvisionadaType | null>;
    handleGetContaProvisionadaByEmpresaId: (empresaId: number) => Promise<ContaProvisionadaType[] | null>;
    listContaProvisionadaByEmpresa: ContaProvisionadaType[];
    setListContaProvisionadaByEmpresa: any;
}

const initialState: ContaProvisionadaContextData = {
    getAllContaProvisionadaPaged: async (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
    ) => {
        return Promise.resolve(null);
    },
    setContaProvisionada: () => { },
    contaProvisionada: {
        id: 0,
        valor: 0,
        taxa: 0,
        dataInicial: "",
        documento: "",
        codigoTransacao: 0,
        historico: "",
        bandeira: "",
        recorrencia: 0,
        contaFinanceiraId: 0,
        contaFinanceiraName: "",
        categoriaFinanceiraId: 0,
        categoriaFinanceiraName: "",
        formaPagamentoId: 0,
        formaPagamentoName: "",
        tipoContaPagarId: 0,
        tipoContaPagarName: "",
    },
    setListContaProvisionada: () => { },
    listContaProvisionada: [],
    setInitialListContaProvisionada: () => { },
    initialListContaProvisionada: [],
    setContaProvisionadaPageCount: () => { },
    contaProvisionadaPageCount: 0,
    createContaProvisionada: async (createContaProvisionadaType: CreateContaProvisionadaType) => {
        return Promise.resolve(null);
    },
    updateContaProvisionada: async (updateContaProvisionadaType: UpdateContaProvisionadaType) => {
        return Promise.resolve(null);
    },
    deleteContaProvisionada: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetContaProvisionadaByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listContaProvisionadaByEmpresa: [],
    setListContaProvisionadaByEmpresa: () => { },
};

export const ContaProvisionadaContext =
    createContext<ContaProvisionadaContextData>(initialState);

export default function ContaProvisionadaContextProvider({
    children,
}: ContaProvisionadaContextProviderProps) {
    const {
        getAllContaProvisionadaPaged,
        createContaProvisionada,
        updateContaProvisionada,
        deleteContaProvisionada,
        contaProvisionada,
        setContaProvisionada,
        setListContaProvisionada,
        listContaProvisionada,
        initialListContaProvisionada,
        setInitialListContaProvisionada,
        setContaProvisionadaPageCount,
        contaProvisionadaPageCount,
        handleGetContaProvisionadaByEmpresaId,
        listContaProvisionadaByEmpresa,
        setListContaProvisionadaByEmpresa,
    } = useContaProvisionada();

    return (
        <ContaProvisionadaContext.Provider
            value={{
                getAllContaProvisionadaPaged,
                createContaProvisionada,
                updateContaProvisionada,
                deleteContaProvisionada,
                contaProvisionada,
                setContaProvisionada,
                setListContaProvisionada,
                listContaProvisionada,
                initialListContaProvisionada,
                setInitialListContaProvisionada,
                setContaProvisionadaPageCount,
                contaProvisionadaPageCount,
                handleGetContaProvisionadaByEmpresaId,
                listContaProvisionadaByEmpresa,
                setListContaProvisionadaByEmpresa,
            }}
        >
            {children}
        </ContaProvisionadaContext.Provider>
    );
}